import React from 'react';

import { tGridTemplateColumns } from '../../react-pages/HomePage/OurProducts/OurProducts';
import { IProduct } from '../../interfaces/product';
import { CardGridHeader } from './CardGridHeader';
import { CardGrid } from './CardGrid';

interface CardGridContainerProps {
  gridColumns: tGridTemplateColumns;
  setGridColumns: React.Dispatch<React.SetStateAction<tGridTemplateColumns>>;
  products: IProduct[];
  title: string;
  titleIcon?: React.ReactNode;
  imageHeight?: number;
  loading?: boolean;
  forProductPage?: boolean;
  slider?: boolean;
}

export const CardGridContainer: React.FC<CardGridContainerProps> = ({
  gridColumns,
  setGridColumns,
  title,
  products,
  titleIcon,
  imageHeight,
  loading,
  forProductPage,
  slider,
}) => {
  return (
    <>
      <CardGridHeader
        gridColumns={gridColumns}
        setGridColumns={setGridColumns}
        headerTitle={title}
        titleIcon={titleIcon}
      />
      <CardGrid
        gridColumns={gridColumns}
        products={products}
        imageHeight={imageHeight}
        loading={loading}
        forProductPage={forProductPage}
        slider={slider}
      />
    </>
  );
};
